export default {"src":"/_next/static/media/dollars_cyan.62a6c6e8.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};